<template>
  <div id="app_settings">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />

    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex pa-4>
        <v-card id="app_height">
          <v-layout wrap justify-center>
            <v-flex xs12 sm2 md1 pt-8 text-center>
              <v-btn x-large icon router-link to="/Settings">
                <v-img src="../../assets/icons/back.png" aspect-ratio="1" contain height="400">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-btn>
            </v-flex>
            <v-flex xs12 sm8 md10 pt-12 text-center>
              <span style="font-size:28px;font-weight:500;color:#464646">KYC</span>
            </v-flex>
            <v-flex xs12 sm2 md1></v-flex>
          </v-layout>
          <v-layout pt-4 wrap justify-center px-2>
            <v-flex xs12 sm12 md8>
              <v-layout py-2 wrap justify-center>
                <v-flex xs10 sm10 md6 text-center>
                  <v-layout wrap>
                    <v-flex text-left>
                      <span style="font-size:16px;font-weight:500;">KYC Status</span>
                    </v-flex>
                    <v-flex text-right>
                      <span style="font-size:16px;font-weight:500;">{{userData.kycstatus}}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout py-2 wrap justify-center>
                <v-flex xs10 sm10 md6 text-left>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <div v-if="userData.kycstatus=='Rejected'">
                <v-layout py-2 wrap justify-center>
                  <v-flex xs10 sm10 md6 text-center>
                    <v-layout wrap>
                      <v-flex text-left>
                        <span style="font-size:16px;font-weight:500;">Reason</span>
                      </v-flex>
                      <v-flex text-right>
                        <span style="font-size:16px;font-weight:500;">{{userData.reason}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout py-2 wrap justify-center>
                  <v-flex xs10 sm10 md6 text-left>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </div>
              <div v-if="userData.rejecteddocuments.length > 0">
                <v-layout py-2 wrap justify-center>
                  <v-flex xs10 sm10 md6 text-center>
                    <v-layout wrap>
                      <v-flex text-left>
                        <span style="font-size:16px;font-weight:500;">Rejected Documents</span>
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        v-for="(item,i) in userData.rejecteddocuments"
                        :key="i"
                        text-right
                      >
                        <span style="font-size:16px;font-weight:500;">{{item}}</span>&nbsp;
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout py-2 wrap justify-center>
                  <v-flex xs10 sm10 md6 text-left>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </div>

              <v-layout py-2 wrap justify-center>
                <v-flex xs10 sm10 md6 text-center>
                  <v-layout wrap>
                    <v-flex text-left>
                      <span style="font-size:16px;font-weight:500;">Supporting Evidence Number</span>
                    </v-flex>
                    <v-flex text-right>
                      <span
                        style="font-size:16px;font-weight:500;"
                      >{{userData.individual.supportingEvidence}}</span>
                      <span
                        style="font-size:12px;font-weight:400;"
                      >({{userData.individual.supportingEvidenceName}})</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout py-2 wrap justify-center>
                <v-flex xs10 sm10 md6 text-left>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout py-2 wrap justify-center>
                <v-flex xs10 sm10 md6 text-center>
                  <v-layout wrap>
                    <v-flex text-left>
                      <span style="font-size:16px;font-weight:500;">Documents</span>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      v-for="(item,i) in userData.documents"
                      :key="i"
                      text-right
                    >
                      <span style="font-size:16px;font-weight:500;">{{item.orginalname}}</span>&nbsp;
                      <span style="font-size:16px;font-weight:500;">({{item.name}}</span>&nbsp;
                      <span
                        style="font-size:16px;font-weight:500;"
                        v-if="item.type!='Accreditation Doc'"
                      >{{item.remark}}</span>
                      <span style="font-size:16px;font-weight:500;">)</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout py-2 wrap justify-center>
                <v-flex xs10 sm10 md6 text-left>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      trash: null,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      userData: {
        individual: {
          supportingEvidence: null
        },
        rejecteddocuments: []
      }
    };
  },
  mounted() {
    this.getProfile();
  },
  watch: {},
  methods: {
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.userData = response.data.data;
          this.appLoading = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
#app_settings {
  background-image: url("../../assets/home_header.png");
  /* background-color: #26af82; */
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

#app_height {
  min-height: 80vh;
}
.curpswd.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>